import { render, staticRenderFns } from "./ChalanDesign.vue?vue&type=template&id=846cfe32&scoped=true&"
import script from "./ChalanDesign.vue?vue&type=script&lang=js&"
export * from "./ChalanDesign.vue?vue&type=script&lang=js&"
import style0 from "./ChalanDesign.vue?vue&type=style&index=0&id=846cfe32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "846cfe32",
  null
  
)

export default component.exports